import { Injectable } from "@angular/core";
import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
  HttpParams,
} from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError, map, tap } from "rxjs/operators";
import { Router } from "@angular/router";
import { environment } from "environments/environment";
import { localStorageService } from "./local-storage.service";
import { AuthService } from "./auth.service";
import { retry } from "rxjs/operators";
import { ScrollbarHelper } from "@swimlane/ngx-datatable";

interface ApiResponse {
  data: any; // Define the type of 'data' based on your API response structure, e.g., `any[]` or a specific shape.
}

@Injectable({
  providedIn: "root",
})
export class ApisService {
  apiUrl: string;

  // domain
  private domain = environment.apiUrl;

  DepartmentsAdd: any[] = [];
  password: any[] = [];
  email: any[] = [];

  constructor(
    private http: HttpClient,
    private router: Router,
    private authService: AuthService,
    private localStorage: localStorageService,
  ) {}

  /*----------  Creating Header   ----------*/
  createHeaders(): HttpHeaders {
    const token = localStorage.getItem("token") || "default_token";
    return new HttpHeaders({
      Accept: "application/json",
      "Accept-Language": "en",
      Authorization: `Bearer ${token}`,
    });
  }

  private request(
    method: "GET" | "POST" | "PUT" | "PATCH" | "DELETE",
    endpoint: string,
    data?: any,
    params?: HttpParams,
  ): Observable<any> {
    let headers = this.createHeaders();
    if (data instanceof FormData) headers = headers.delete("Content-Type");

    return this.http
      .request(method, `${this.domain}${endpoint}`, {
        body: ["POST", "PUT", "PATCH"].includes(method) ? data : null,
        headers,
        params: params || new HttpParams(),
      })
      .pipe(
        tap((response) => console.log(`[${method}] ${endpoint} =>`, response)),
        catchError(this.handleError.bind(this)),
      );
  }

  /*=============================================
=            CALLING Methods            =
=============================================*/
  get(endpoint: string, params?: HttpParams): Observable<any> {
    return this.request("GET", endpoint, null, params);
  }

  post(endpoint: string, data: any, params?: HttpParams): Observable<any> {
    return this.request("POST", endpoint, data, params);
  }

  put(endpoint: string, data: any): Observable<any> {
    return this.request("PUT", endpoint, data);
  }

  patch(endpoint: string, data: any): Observable<any> {
    return this.request("PATCH", endpoint, data);
  }

  delete(endpoint: string): Observable<any> {
    return this.request("DELETE", endpoint);
  }

  /*=====  End of Fetching Methods  ======*/

  /*----------  Error Handling  ----------*/
  private handleError(error: HttpErrorResponse): Observable<never> {
    console.error("API Error:", error);
    if (error.status === 401 || error.error?.message === "Unauthenticated.") {
      this.router.navigate(["pages/authentication/login-v2"]);
    }
    return throwError(error);
  }

  company() {
    return this.http.post(this.domain + "/dashboard/companies", {});
  }

  requestAds(): Observable<any> {
    return this.http.post<any>(this.domain + "user-sliders", {});
  }

  // levels(): Observable<any> {
  //   return this.authenticatedGet(
  //     `${this.domain}/api/dashboard-auth-api/levels`
  //   );
  // }

  // article() {
  //   return this.http.post(this.domain + '/articles',{});
  // }

  article(): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.domain + "articles", {});
  }

  about(): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.domain + "about-app", {});
  }

  getCountry(): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.domain + "countries", {});
  }

  LoginOtp(data: any, token: any): Observable<any> {
    const header = new HttpHeaders().set("Authorization", `Bearer ${token}`);
    return this.http.post(`${this.domain}user/active-profile`, data, {
      headers: header,
    });
  }
  completeProfile(token: any, data: any) {
    return this.http.post(`${this.domain}user/update-profile`, data, {
      headers: new HttpHeaders().set("Authorization", `Bearer ${token}`),
    });
  }
  countries(): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.domain + "countries", {});
  }

  ganatakCommunity(): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.domain + "community-posts", {});
  }

  plantCards(): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.domain + "user/make-order", {});
  }

  // orders(): Observable<ApiResponse> {
  //   return this.http.get<ApiResponse>(this.domain + '/api/dashboard-store-auth-api/orders', {});
  // }
  orders(): Observable<ApiResponse> {
    const token = localStorage.getItem("userToken");

    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
      "Accept-Language": "en",
    });

    return this.http.get<ApiResponse>(
      this.domain + "/api/dashboard-store-auth-api/orders",
      { headers },
    );
  }

  categories(): Observable<ApiResponse> {
    const token = localStorage.getItem("userToken");

    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
      "Accept-Language": "en",
    });

    return this.http.get<ApiResponse>(
      this.domain + "/api/dashboard-store-auth-api/categories",
      { headers },
    );
  }

  //  addCategories(payload: any): Observable<ApiResponse> {
  //   const token = localStorage.getItem('userToken');

  //   const headers = new HttpHeaders({
  //     Authorization: `Bearer ${token}`,
  //     'Accept-Language': 'en'
  //   });

  //   return this.http.post<ApiResponse>(
  //     this.domain + '/dashboard-auth-api/categories',payload,
  //     { headers }
  //   );
  // }

  addCategories(payload: { categoryName: string }): Observable<any> {
    return this.post(`/dashboard-auth-api/categories`, payload);
  }

  //  deeteCategories(): Observable<ApiResponse> {
  //   const token = localStorage.getItem('userToken');

  //   const headers = new HttpHeaders({
  //     Authorization: `Bearer ${token}`,
  //     'Accept-Language': 'en'
  //   });

  //   return this.http.delete<ApiResponse>(
  //     this.domain + '/api/dashboard-store-auth-api/categories',
  //     { headers }
  //   );
  // }

  deleteCategories(id: number): Observable<ApiResponse> {
    const token = localStorage.getItem("userToken");

    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
      "Accept-Language": "en",
    });

    return this.http.delete<ApiResponse>(
      `${this.domain}/api/dashboard-store-auth-api/categories/${id}`,
      { headers },
    );
  }

  deleteStore(id: number): Observable<ApiResponse> {
    const token = localStorage.getItem("userToken");

    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
      "Accept-Language": "en",
    });

    return this.http.delete<ApiResponse>(
      `${this.domain}/api/dashboard-auth-api/blogs/${id}`,
      { headers },
    );
  }

  // addCategories(payload: any): Observable<any> {
  //   return this.http.post(`${this.domain}/api/dashboard-store-auth-api/categories`, payload, {
  //     headers: {
  //       'Accept-Language': 'en',
  //       'Content-Type': 'application/json'
  //     }
  //   });
  // }

  store(): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(
      this.domain + "active-store-products",
      {},
    );
  }
  users(): Observable<any> {
    return this.http.post<any>(this.domain + "user/login", {});
  }
  companies(service_id: any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.domain + "service-companies", {
      service_id: service_id,
    });
  }
  //Consulting List
  requestConsultations(): Observable<ApiResponse> {
    //waiting for the token
    // const Authorization = '1myQSGIIuD22gI3iruJXWOILoysWAOtF02y1P7XX'
    // const httpheaders :HttpHeaders = new HttpHeaders ().set(
    //   'Authorization' , `Bearer ${Authorization}`
    // )
    return this.http.post<ApiResponse>(
      this.domain + "user/user-consultants",
      {},
    );
  }
  //edit consultation
  requestConsultationDetail(consulting_id: any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.domain + "user/make-consultant", {
      consulting_id: consulting_id,
    });
  }
  //make consultation
  requestConsultationBook(): Observable<ApiResponse> {
    const headers = HttpHeaders;
    return this.http.post<ApiResponse>(
      this.domain + "user/consultant-details",
      {},
    );
  }

  requestTerms(): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.domain + "terms-app", {});
  }

  requestTagArticles(tag_id: any): Observable<ApiResponse> {
    //authorization needed

    return this.http.post<ApiResponse>(this.domain + "tag-articles", {
      tag_id: tag_id,
    });
  }

  requestTagProducts(tag_id: any): Observable<ApiResponse> {
    //authorization needed
    return this.http.post<ApiResponse>(this.domain + "tag-products", {
      tag_id: tag_id,
    });
  }

  requestNotificationsCount(): Observable<ApiResponse> {
    //authorization needed
    return this.http.post<ApiResponse>(
      this.domain + "user-notifications-count",
      {},
    );
  }

  requestNotifications(page: any): Observable<ApiResponse> {
    //authorization needed
    return this.http.post<ApiResponse>(this.domain + "user-notifications", {
      page: page,
    });
  }

  requestNotificationSee(notification_id: any): Observable<ApiResponse> {
    //authorization needed
    return this.http.post<ApiResponse>(
      this.domain + "user-seen-notifications",
      { notification_id: notification_id },
    );
  }

  requestServiceCategories(): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.domain + "services", {});
  }

  requestServiceSubCategories(): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.domain + "sub-services", {});
  }

  requestOffers(
    page: number,
    category_id: string,
    discount_sort: string,
    keyword: string,
  ): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.domain + "search-offers", {
      page: page,
      category_id: category_id,
      discount_sort: discount_sort,
      keyword: keyword,
    });
  }
  requestHomeOffers(): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.domain + "home-products", {});
  }

  requestCategoryOffers(category_id: number): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.domain + "category-offer", {
      category_id: category_id,
    });
  }

  requestCancelReasons(): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(
      this.domain + "user/cancelOrderReasons",
      {},
    );
  }
  requestCancelOrder(
    order_id: number,
    cancellation_reason_id: number,
  ): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.domain + "user/cancelOrder", {
      order_id: order_id,
      cancellation_reason_id: cancellation_reason_id,
    });
  }
  requestMarketCategories(): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.domain + "categories-list", {});
  }

  requestShops(): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.domain + "category-stores", {});
  }
  requestShopProductsCategories(shop_id: number): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.domain + "store-id-categories", {
      shop_id: shop_id,
    });
  }

  requestShopProducts(): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(
      this.domain + "store-category-id-products",
      {},
    );
  }
  requestProducts(): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(
      this.domain + "category-store-id-products",
      {},
    );
  }
  requestArticleCategories(): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(
      this.domain + "articles-categories-list",
      {},
    );
  }

  // companyRate(companyId: any): Observable<any> {
  //   return this.http.post(`${this.domain}/dashboard/company-rates`, { companyId: companyId });
  // }

  // Login(email: any, password: any) {
  //       const headers = new HttpHeaders().set('Content-Type', 'application/json');

  //   return this.http.post('https://qaiim.newegyptgroup.com/api/dashboard/admin-login', { email, password }, {headers});
  // }

  // removeDepartment(departmentId: any): Observable<any> {
  //   return this.http.post(`${this.domain}/dashboard/remove-department`,{departmentId});
  // }

  getLogin(data: any): Observable<any> {
    const url = `${this.domain}user/login`;
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
    });

    return this.http
      .post(url, data, { headers })
      .pipe(catchError(this.handleError));
  }

  /*=============================================
=            Users API            =
=============================================*/

  /*----------  Get All users  ----------*/
  // getAllUsers(page: any):Observable<any> {
  //   return this.get(`/dashboard-auth-api/users?page=${page}`);

  // }
  getAllUsersSearch(keyword: string): Observable<any> {
    return this.get(
      `/dashboard-auth-api/users/search?keyword=${encodeURIComponent(keyword)}`,
    );
  }

  // Users list (dashboard)
  getAllUsers(page: number, search: string = "", per_page: number = 10): Observable<any> {
    let url = `/dashboard-auth-api/users?page=${page}&per_page=${per_page}`;

    if (search && search.trim() !== "") {
      url += `&search=${encodeURIComponent(search)}`;
    }

    return this.get(url);
  }

  userDetails(id: number): Observable<any> {
    return this.get(`/dashboard-auth-api/users/${id}`);
  }

  getUserFollowing(id: any): Observable<any> {
    return this.post(`/dashboard-auth-api/UserFollowingList?user_id=${id}`, {});
  }

  getUserFollowers(id: any): Observable<any> {
    return this.post(`/dashboard-auth-api/UserFollowersList?user_id=${id}`, {});
  }

  getUserArticles(id: any): Observable<any> {
    return this.post(`/dashboard-auth-api/UserArticles?user_id=${id}`, {});
  }

  deleteUser(id: number): Observable<any> {
    return this.delete(`/dashboard-auth-api/users/${id}`);
  }

  SendNotification(
    id: number,
    data: { title: string; body: string },
  ): Observable<any> {
    return this.post(`/dashboard-auth-api/send-notification/${id}`, data);
  }

  SendNotifications(data: {
    user_id: number;
    title: string;
    body: string;
  }): Observable<any> {
    return this.post(`/dashboard-auth-api/send-notification`, data);
  }

  dailyUsers(page: any): Observable<any> {
    return this.get(`/dashboard-auth-api/lastLoggedUsers?page=${page}`);
  }

  editUser(id: any, data: any): Observable<any> {
    if (data instanceof FormData) {
      data.append("_method", "PUT");
      return this.post(`/dashboard-auth-api/users/${id}`, data);
    }

    return this.put(`/dashboard-auth-api/users/${id}`, data);
  }

  /*=====  End of Users API  ======*/

  /*=============================================
=            Fake Users APi Section            =
=============================================*/
  getFakeUsers(page: any, per_page: number = 10): Observable<any> {
    return this.get(`/dashboard-auth-api/fake-users?page=${page}&per_page=${per_page}`);
  }

  getSocialLinks(): Observable<any> {
    return this.get(`/dashboard-auth-api/social-links`);
  }

  // getHomeStatistics():Observable<any> {
  //   return this.get('/dashboard-auth-api/statistics');
  // }

  getHomeStatistics(): Observable<any> {
    const token = localStorage.getItem("token");

    return this.http.get<any>(this.domain + "/dashboard-auth-api/statistics", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  }

  Statistics(): Observable<ApiResponse> {
    const token = localStorage.getItem("userToken");

    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
      "Accept-Language": "en",
    });

    return this.http.get<ApiResponse>(
      this.domain + "/dashboard-auth-api/statistics",
      { headers },
    );
  }

  deleteFakeUsers(id: number): Observable<any> {
    return this.delete(`/dashboard-auth-api/fake-users/${id}`);
  }

  deleteSocialLinks(id: number): Observable<any> {
    return this.delete(`/dashboard-auth-api/social-links/${id}`);
  }

  deleteComments(id: number): Observable<any> {
    return this.delete(`/dashboard-auth-api/comment/${id}`);
  }

  addFakeUser(id: number, body: any): Observable<any> {
    return this.post(`/dashboard-auth-api/fake-users`, body);
  }

  addSocialLinks(id: number, body: any): Observable<any> {
    return this.post(`/dashboard-auth-api/social-links`, body);
  }

  editFakeUser(id: number, body: any): Observable<any> {
    return this.put(`/dashboard-auth-api/fake-users/${id}`, body);
  }

  editSocialLinks(id: number, body: any): Observable<any> {
    return this.put(`/dashboard-auth-api/social-links/${id}`, body);
  }

  suserDetails(id: number): Observable<any> {
    return this.get(`/dashboard-auth-api/fake-users/${id}`);
  }

  getFakeUserById(id: number): Observable<any> {
    return this.get(`/dashboard-auth-api/fake-users/${id}`);
  }

  getSocialLinksById(id: number): Observable<any> {
    return this.get(`/dashboard-auth-api/social-links/${id}`);
  }

  editFakeUserById(id: number): Observable<any> {
    return this.put(`/dashboard-auth-api/fake-users/${id}`, {});
  }

  /*=====  End of Fake Users APi Section  ======*/

  /*=============================================
=            Books API Section            =
=============================================*/
  // getBooks(page: any):Observable<any> {
  //   return this.get(`/dashboard-auth-api/books?page=${page}`);
  // }

  getBooks(page: any, search: string = ""): Observable<any> {
    return this.get(`/dashboard-auth-api/books?page=${page}&search=${search}`);
  }

  getMostBooks(page: any, search: string = ""): Observable<any> {
    return this.get(
      `/dashboard-auth-api/mostviewbooks?page=${page}&search=${search}`,
    );
  }

  deleteBooks(id: number): Observable<any> {
    return this.delete(`/dashboard-auth-api/books/${id}`);
  }

  addBook(id: number, body: any): Observable<any> {
    return this.post(`/dashboard-auth-api/books`, body);
  }

  addBookStore(id: number, body: any): Observable<any> {
    return this.post(`/dashboard-auth-api/store/book`, body);
  }

  editBook(id: number, body: any): Observable<any> {
    return this.post(`/dashboard-auth-api/book/${id}`, body);
  }

  editOpenScreen(id: number, body: any): Observable<any> {
    return this.post(`/dashboard-auth-api/openScreens/${id}`, body);
  }

  editLinks(id: number, body: any): Observable<any> {
    return this.post(`/dashboard-auth-api/edit/book/${id}`, body);
  }

  getBookById(id: number): Observable<any> {
    return this.get(`/dashboard-auth-api/books/${id}`);
  }

  getOpenScreensById(id: number): Observable<any> {
    return this.get(`/dashboard-auth-api/openScreens/${id}`);
  }

  getReportsById(id: number): Observable<any> {
    return this.get(`/dashboard-auth-api/reports/${id}`);
  }

  /*=====  End of Books API Section  ======*/

  /*=============================================
=            Articles API Section            =
=============================================*/
  getArticles(page: any): Observable<any> {
   return this.get(`/dashboard-auth-api/articles?page=${page}`);
 }

  getArticleFormData(): Observable<any> {
    return this.get("/dashboard-auth-api/articles?page=1");
  }

  createArticle(body: FormData): Observable<any> {
    return this.post("/dashboard-auth-api/articles", body);
  }

 getArticlesDetails(id: any): Observable<any> {
  return this.get(`/dashboard-auth-api/articles/${id}`);
}

  addArticleComment(id: number | string, body: { fake_user_id: number | string; comment: string }): Observable<any> {
    return this.post(`/dashboard-auth-api/articlescomment/${id}`, body);
  }

  addArticleLike(id: number | string, fake_user_id: number | string): Observable<any> {
    return this.get(`/dashboard-auth-api/articleslike/${id}?fake_user_id=${fake_user_id}`);
  }

  addArticleDislike(id: number | string, fake_user_id: number | string): Observable<any> {
    return this.get(`/dashboard-auth-api/articlesdislike/${id}?fake_user_id=${fake_user_id}`);
  }

  getArticleLikes(articleId: number | string, page: number = 1): Observable<any> {
    return this.post("/articleLikes", {
      article_id: articleId,
      page
    });
  }

 deleteArticlesss(): Observable<any> {
    return this.delete("/dashboard-auth-api/articles/${id}");
  }

  // deleteArticles(id: number):Observable<any> {
  //   return this.delete('/dashboard-auth-api/articles/${id}' );
  // }
  deleteArticles(id: number): Observable<any> {
    return this.delete(`/dashboard-auth-api/articles/${id}`);
  }
  /*=====  End of Articles API Section  ======*/

  /*=============================================
=            MAin Category API             =
=============================================*/
  getMainCategories(page?: any): Observable<any> {
    return this.get(`/dashboard-auth-api/categories?page=${page}`);
  }
  getMainCategoriess(): Observable<any> {
    return this.post(`/dashboard-auth-api/all-categories`, {});
  }
  getMainSubCategories(id: any): Observable<any> {
    return this.post(`/dashboard-auth-api/subcategories/${id}`, {});
  }

  showMainCategories(id: any): Observable<any> {
    return this.get(`/dashboard-auth-api/categories/${id}`);
  }

  deleteMainCategories(id: number): Observable<any> {
    return this.delete(`/dashboard-auth-api/categories/${id}`);
  }

  addMainCategories(data: any): Observable<any> {
    return this.post(`/dashboard-auth-api/categories`, null, data);
  }

  editMainCategories(id: number, data: any): Observable<any> {
    return this.put(
      `/dashboard-auth-api/categories/${id}?categoryName=${data}`,
      null,
    );
  }

  /*=====  End of MAin Category API   ======*/

  /*=============================================
=            Contests Dashboard API            =
=============================================*/
  getDashboardContests(): Observable<any> {
    return this.get(`/dashboard-auth-api/contests`);
  }

  createDashboardContest(data: any): Observable<any> {
    return this.post(`/dashboard-auth-api/contests`, data);
  }

  updateDashboardContest(data: any): Observable<any> {
    return this.post(`/dashboard-auth-api/contests/${data.contest_id}`, data);
  }

  deleteDashboardContest(contest_id: number): Observable<any> {
    return this.delete(`/dashboard-auth-api/contests/${contest_id}`);
  }

  getDashboardContestEntries(contest_id: number): Observable<any> {
    return this.get(`/dashboard-auth-api/contests/${contest_id}/entries`);
  }

  getDashboardStories(): Observable<any> {
    return this.get(`/dashboard-auth-api/stories`);
  }

  getDashboardStoryDetails(storyId: number): Observable<any> {
    return this.get(`/dashboard-auth-api/stories/${storyId}`);
  }

  updateDashboardStory(storyId: number, data: { title?: string; content?: string; cover?: string; status?: string; reason?: string }): Observable<any> {
    return this.post(`/dashboard-auth-api/stories/${storyId}`, data);
  }

  uploadDashboardStoryCover(storyId: number, cover: File): Observable<any> {
    const fd = new FormData();
    fd.append('cover', cover);
    return this.post(`/dashboard-auth-api/stories/${storyId}/cover`, fd);
  }

  uploadDashboardStoryImages(storyId: number, images: File[]): Observable<any> {
    const fd = new FormData();
    images.forEach((f) => fd.append('images[]', f));
    return this.post(`/dashboard-auth-api/stories/${storyId}/images`, fd);
  }

  deleteDashboardStoryImage(storyId: number, imageId: number): Observable<any> {
    return this.delete(`/dashboard-auth-api/stories/${storyId}/images/${imageId}`);
  }

  reorderDashboardStoryImages(storyId: number, imageIds: number[]): Observable<any> {
    return this.post(`/dashboard-auth-api/stories/${storyId}/images/reorder`, { image_ids: imageIds });
  }

  getDashboardWriters(): Observable<any> {
    return this.get(`/dashboard-auth-api/writers`);
  }

  /*=============================================
=            Monetization (Dashboard)           =
=============================================*/
  getDashboardMonetizationTerms(): Observable<any> {
    return this.get(`/dashboard-auth-api/monetization/terms`);
  }

  createDashboardMonetizationTerms(data: any): Observable<any> {
    return this.post(`/dashboard-auth-api/monetization/terms`, data);
  }

  updateDashboardMonetizationTerms(id: number, data: any): Observable<any> {
    return this.post(`/dashboard-auth-api/monetization/terms/${id}`, data);
  }

  activateDashboardMonetizationTerms(id: number): Observable<any> {
    return this.post(`/dashboard-auth-api/monetization/terms/${id}/activate`, {});
  }

  getDashboardMonetizationRequests(status: string = 'pending'): Observable<any> {
    const params = new HttpParams().set('status', status);
    return this.get(`/dashboard-auth-api/monetization/requests`, params);
  }

  approveDashboardMonetizationRequest(id: number, data: any): Observable<any> {
    return this.post(`/dashboard-auth-api/monetization/requests/${id}/approve`, data || {});
  }

  rejectDashboardMonetizationRequest(id: number, data: any): Observable<any> {
    return this.post(`/dashboard-auth-api/monetization/requests/${id}/reject`, data || {});
  }

  disableDashboardMonetizationRequest(id: number, data: any): Observable<any> {
    return this.post(`/dashboard-auth-api/monetization/requests/${id}/disable`, data || {});
  }

  enableDashboardMonetizationRequest(id: number, data: any): Observable<any> {
    return this.post(`/dashboard-auth-api/monetization/requests/${id}/enable`, data || {});
  }

  updateDashboardStoryStatus(storyId: number, status: string, reason?: string): Observable<any> {
    const body: any = { status };
    if (reason && reason.trim() !== '') body.reason = reason;
    return this.post(`/dashboard-auth-api/stories/${storyId}/status`, body);
  }

  getDashboardContestEntryDetails(entryId: number): Observable<any> {
    return this.get(`/dashboard-auth-api/contests/entries/${entryId}`);
  }

  approveDashboardContestEntry(entryId: number): Observable<any> {
    return this.post(`/dashboard-auth-api/contests/entries/${entryId}/approve`, {});
  }

  rejectDashboardContestEntry(entryId: number): Observable<any> {
    return this.post(`/dashboard-auth-api/contests/entries/${entryId}/reject`, {});
  }

  setDashboardContestWinner(contestId: number, entryId: number, winnerNote?: string): Observable<any> {
    return this.post(`/dashboard-auth-api/contests/${contestId}/winner`, { entry_id: entryId, winner_note: winnerNote || null });
  }

  clearDashboardContestWinner(contestId: number): Observable<any> {
    return this.post(`/dashboard-auth-api/contests/${contestId}/winner/clear`, {});
  }

  /*=====  End of Contests Dashboard API  ======*/

  getReports(page: any): Observable<any> {
    return this.get(`/dashboard-auth-api/reports`);
  }

  getaskBooks(page: any): Observable<any> {
    return this.get(`/dashboard-auth-api/askBook`);
  }

  getEmailClick(page: any): Observable<any> {
    return this.post(`/dashboard-auth-api/email-click`, {});
  }

  /*=============================================
=            Sub-Categories API            =
=============================================*/
  getSubCategories(page: any): Observable<any> {
    return this.get(`/dashboard-auth-api/subcategories?page=${page}`);
  }

  deleteSubCategories(id: number): Observable<any> {
    return this.delete(`/dashboard-auth-api/subcategories/${id}`);
  }
  editSubCategory(
    id: any,
    subCategoryName: any,
    categoryId: any,
  ): Observable<any> {
    return this.put(
      `/dashboard-auth-api/subcategories/${id}?subCategoryName=${subCategoryName}&categoryId=${categoryId}`,
      {},
    );
  }

  addSubCategory(subCategoryName: any, categoryId: any): Observable<any> {
    return this.post(
      `/dashboard-auth-api/subcategories?subCategoryName=${subCategoryName}&categoryId=${categoryId}`,
      {},
    );
  }

  /*=====  End of Sub-Categories API  ======*/

  /*=============================================
=            Open Screen API            =
=============================================*/
  getOpenScreens(page: any): Observable<any> {
    return this.get(`/dashboard-auth-api/openScreens?page=${page}`);
  }

  deleteOpenScreens(id: number): Observable<any> {
    return this.delete(`/dashboard-auth-api/openScreens/${id}`);
  }

  addOpenScreens(data: any): Observable<any> {
    return this.post(`/dashboard-auth-api/openScreens`, data);
  }

  /*=====  End of Open Source API  ======*/

  /*=============================================
=            Chats API            =
=============================================*/
  getChats(page: any): Observable<any> {
    return this.get(`/dashboard-auth-api/support/rooms?page=${page}`);
  }

  getChatMessages(id: number): Observable<any> {
    return this.get(`/dashboard-auth-api/support/rooms/${id}/messages?page=1`);
  }

  deleteChat(id: number): Observable<any> {
    return this.delete(`/dashboard-auth-api/support/rooms/${id}`);
  }

  sendMessage(room_id: any, data: any): Observable<any> {
    return this.post(
      `/dashboard-auth-api/support/rooms/${room_id}/reply`,
      data,
    );
  }

  uploadFile(room_id: any, data: any): Observable<any> {
    return this.post(
      `/dashboard-auth-api/support/rooms/${room_id}/reply`,
      data,
    );
  }

  viewChats(): Observable<any> {
    return this.get(`/dashboard-auth-api/chat/rooms?page=1`);
  }

  openAdminChatWithUser(user_id: number): Observable<any> {
    return this.post(`/dashboard-auth-api/chat/users/${user_id}/open`, {});
  }

  openFakeChatWithUser(fake_user_id: number, user_id: number): Observable<any> {
    return this.post(`/dashboard-auth-api/chat/fake-users/${fake_user_id}/users/${user_id}/open`, {});
  }

  roomMessages(room_id: number, page: number = 1, per_page: number = 20, latest: boolean = true): Observable<any> {
    return this.get(
      `/dashboard-auth-api/chat/rooms/${room_id}/messages?page=${page}&per_page=${per_page}&latest=${latest ? 1 : 0}`
    );
  }

  sendAdminChatMessage(room_id: any, data: any): Observable<any> {
    return this.post(`/dashboard-auth-api/chat/rooms/${room_id}/reply`, data);
  }

  sendChatMessageAsUser(room_id: any, data: any): Observable<any> {
    return this.post(`/dashboard-auth-api/chat/rooms/${room_id}/send-as-user`, data);
  }
  /*=====  End of Chats API  ======*/
}
